import { useSelector, useDispatch } from 'react-redux';
import FJClothesChangerRight from './FJClothesChangerRight';
import {
    setSliceCreationListAction,
    setSliceHistoryListAction,
    setSliceSelectListAction,
    setSliceIsDraggingFileAction,
} from '../../../redux/slices/FJSliceCommon';
import FJActionClothesChanger from '../../../redux/action/FJActionClothesChanger';
import { useCallback, useState } from 'react';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionModal from '../../../redux/action/FJActionModal';
import FJActionCommon from '../../../redux/action/FJActionCommon';

const FJClothesChangerRightContainer = () => {
    useLocalStore();
    const historyList = useSelector(state => state.common.historyList);
    const selectList = useSelector(state => state.common.selectList);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const taskStatus = useSelector(state => state.common.taskStatus);
    const progress = useSelector(state => state.common.progress);
    const currentQueue = useSelector(state => state.common.currentQueue);
    const queueNumber = useSelector(state => state.common.queueNumber);
    const creationList = useSelector(state => state.common.creationList);
    const appType = useSelector(state => state.common.appType);
    const isCanDownload = useSelector(state => state.common.isDone);

    const dispatch = useDispatch();

    const [downloadEditImageLoading, setDownloadEditImageLoading] = useState(false);

    const setSliceCreationList = useCallback(
        value => {
            dispatch(setSliceCreationListAction(value));
        },
        [dispatch],
    );
    const setSliceHistoryList = useCallback(
        value => {
            dispatch(setSliceHistoryListAction(value));
        },
        [dispatch],
    );
    const setSliceSelectList = useCallback(
        value => {
            dispatch(setSliceSelectListAction(value));
        },
        [dispatch],
    );

    const multiDownload = useCallback(
        (ids, source, callback) => {
            dispatch(FJActionCommon.multiDownloadAction(ids, source, callback));
        },
        [dispatch],
    );
    const multiDelete = useCallback(
        ids => {
            dispatch(FJActionCommon.multiDeleteAction(ids));
        },
        [dispatch],
    );
    const uploadImg = (file, isClothesImage) => {
        dispatch(FJActionClothesChanger.uploadImageAction(file, isClothesImage));
    };
    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };
    const onCancel = () => {
        dispatch(FJActionClothesChanger.cancelTaskAction());
    };

    const previewImage = data => {
        dispatch(FJActionModal.showPreviewModalDataAction({ data }));
    };
    const reGenerate = id => {
        dispatch(FJActionClothesChanger.reGenerateAction(id));
    };

    const download = () => {
        setDownloadEditImageLoading(true);
        dispatch(FJActionClothesChanger.downloadAllCreationAction(() => setDownloadEditImageLoading(false)));
    };

    const _imageToVideo = () => {
        dispatch(FJActionCommon.imageToVideoAction());
    };

    return (
        <FJClothesChangerRight
            appType={appType}
            historyList={historyList}
            selectList={selectList}
            setSliceCreationList={setSliceCreationList}
            setSliceHistoryList={setSliceHistoryList}
            setSliceSelectList={setSliceSelectList}
            multiDownload={multiDownload}
            multiDelete={multiDelete}
            headerTabIndex={headerTabIndex}
            isDraggingFile={isDraggingFile}
            uploadImg={uploadImg}
            setIsDraggingFile={_setIsDraggingFile}
            taskStatus={taskStatus}
            onCancel={onCancel}
            progress={progress}
            currentQueue={currentQueue}
            queueNumber={queueNumber}
            creationList={creationList}
            previewImage={previewImage}
            reGenerate={reGenerate}
            download={download}
            downloadEditImageLoading={downloadEditImageLoading}
            isCanDownload={isCanDownload}
            imageToVideo={_imageToVideo}
        />
    );
};
export default FJClothesChangerRightContainer;
